import createAccount from './createAccount.vue'



export default {
  install(Vue, i18n){
    const dialog = Vue.extend(createAccount)
    let instance
    createAccount.open = function(input) {
        if(!instance){
          instance = new dialog({
              i18n
          }).$mount()
        }
        document.body.appendChild(instance.$el);
        Vue.nextTick(() => {
          instance.open(input);
        });
      };
    
    Vue.prototype.$createAccount = createAccount;
  }
}